import axios from "axios";

export default function EntrylocationInviteOwnerService(formData, locationId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/entry_location/" + locationId + "/invite",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
